"use strict";

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUriPathArbitrary = void 0;

var Converters_1 = require("../../../check/arbitrary/definition/Converters");

var webSegment_1 = require("../../webSegment");

var array_1 = require("../../array");

var SegmentsToPath_1 = require("../mappers/SegmentsToPath");

function sqrtSize(size) {
  switch (size) {
    case 'xsmall':
      return ['xsmall', 'xsmall'];

    case 'small':
      return ['small', 'xsmall'];

    case 'medium':
      return ['small', 'small'];

    case 'large':
      return ['medium', 'small'];

    case 'xlarge':
      return ['medium', 'medium'];
  }
}

function buildUriPathArbitrary(resolvedSize) {
  var _sqrtSize = sqrtSize(resolvedSize),
      _sqrtSize2 = _slicedToArray(_sqrtSize, 2),
      segmentSize = _sqrtSize2[0],
      numSegmentSize = _sqrtSize2[1];

  return (0, Converters_1.convertFromNext)((0, Converters_1.convertToNext)((0, array_1.array)((0, webSegment_1.webSegment)({
    size: segmentSize
  }), {
    size: numSegmentSize
  })).map(SegmentsToPath_1.segmentsToPathMapper, SegmentsToPath_1.segmentsToPathUnmapper));
}

exports.buildUriPathArbitrary = buildUriPathArbitrary;